export default {
  EXIBIR_CONSULTA_LEGISLACAO: false
}



// WEBPACK FOOTER //
// ./src/constants/ma/dadosEstado/analise.js